import { defineComponent as V, inject as u, computed as _, createElementBlock as k, openBlock as t, Fragment as I, createVNode as d, createElementVNode as g, unref as e, withCtx as n, createCommentVNode as i, normalizeClass as s, mergeProps as y, createBlock as p, renderSlot as T } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Card/card.js";
import { AngleRightIcon as $ } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import E from "../Button.vue2.js";
import { CardExpandableKey as P, CardExpandedKey as S, CardCheckboxKey as K } from "./Card.vue2.js";
import N from "./CardActions.vue2.js";
import x from "../Checkbox.vue2.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
import { createReusableTemplate as j } from "@vueuse/core";
const M = /* @__PURE__ */ V({
  name: "PfCardHeader",
  inheritAttrs: !1,
  __name: "CardHeader",
  props: {
    toggleRightAligned: { type: Boolean },
    toggleButtonAttrs: { default: () => ({}) },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(A, { expose: h }) {
    const f = A, b = U({ id: f.ouiaId, safe: f.ouiaSafe }), [B, c] = j(), H = u(P), m = u(S), a = u(K), v = _({
      get: () => {
        var o;
        return (o = a == null ? void 0 : a.value) == null ? void 0 : o.checked.value;
      },
      set: (o) => {
        a != null && a.value && (a.value.checked.value = !!o);
      }
    });
    function C() {
      m && (m.value = !m.value);
    }
    return h({
      toggle: C
    }), (o, r) => (t(), k(I, null, [
      d(e(B), null, {
        default: n(() => [
          e(H) ? (t(), k("div", {
            key: 0,
            class: s(e(l).cardHeaderToggle)
          }, [
            d(E, y({ variant: "plain" }, o.toggleButtonAttrs, { onClick: C }), {
              default: n(() => [
                g("span", {
                  class: s(e(l).cardHeaderToggleIcon)
                }, [
                  d(e($), { "aria-hidden": "" })
                ], 2)
              ]),
              _: 1
            }, 16)
          ], 2)) : i("", !0)
        ]),
        _: 1
      }),
      g("div", y({ ...e(b), ...o.$attrs }, {
        class: [e(l).cardHeader, {
          [e(l).modifiers.toggleRight]: o.toggleRightAligned
        }]
      }), [
        o.toggleRightAligned ? i("", !0) : (t(), p(e(c), { key: 0 })),
        e(a) ? (t(), p(N, { key: 1 }, {
          default: n(() => [
            g("div", {
              class: s(e(l).cardSelectableActions)
            }, [
              d(x, {
                class: s(["pf-m-standalone", e(a).hidden ? "pf-v6-screen-reader" : void 0]),
                name: e(a).name,
                modelValue: v.value,
                "onUpdate:modelValue": r[0] || (r[0] = (R) => v.value = R),
                disabled: e(a).disabled,
                tabindex: "-1"
              }, {
                label: n(() => r[1] || (r[1] = [])),
                _: 1
              }, 8, ["class", "name", "modelValue", "disabled"])
            ], 2)
          ]),
          _: 1
        })) : i("", !0),
        T(o.$slots, "default"),
        o.toggleRightAligned ? (t(), p(e(c), { key: 2 })) : i("", !0)
      ], 16)
    ], 64));
  }
});
export {
  M as default
};
